import { useLocation } from "react-router";

import { AxiosHttpClient } from "src/http";
import { useUserStore } from "src/stores/user/user.store";
import { useAnalytics } from "src/stores/analytics/analytics.store";
import { useCustomContent } from "src/stores/custom-content/custom-content.store";
import { AnalyticsRepository } from "src/repositories/analytics/analytics.repository";
import { API_URL, TEST_AB_EVENT_ID, FIREBASE_MEASUREMENT_ID } from "src/config-global";

import { useResponsive } from "./use-responsive";


export default function useActionEvent() {
    const { businessUnity, eventData } = useCustomContent((state) => state)
    const lpVersion = useUserStore((state) => state.rdSummitVersion)
    const { analyticsDeviceId } = useAnalytics((state) => state)

    const { addEvent } = useAnalytics((state) => state)

    const api = new AxiosHttpClient(API_URL)
    const analyticsRepository = new AnalyticsRepository(api)

    const isMobile = useResponsive('down', 'md')

    const location = useLocation()

    const sendActionEvent = async (event: string, actionType: string, target: string[], otherData: Object) => {
        addEvent({
            eventType: 'action',
            eventDate: new Date(),
            actionType,
            parameter: event,
            screenName: location.pathname,
            otherData: {
                ...otherData,
                BU: businessUnity?.name,
                lpEvent: eventData?.name,
                BUId: businessUnity?.id,
                eventId: eventData?._id,
                deviceType: isMobile ? 'mobile' : 'desktop',
                lpVersion: lpVersion && eventData?._id === TEST_AB_EVENT_ID ? lpVersion : undefined,
            },
            GAPropertyId: target.includes('lp_analytics') ? eventData?.GAPropertyId! : FIREBASE_MEASUREMENT_ID,
            target
        });
    }

    const sendInstantEvent = async (event: string, actionType: string, target: string[], otherData: Object) => {
        analyticsRepository.sendInstantEvent([{
            eventType: 'action',
            eventDate: new Date(),
            actionType,
            parameter: event,
            screenName: location.pathname,
            otherData: {
                ...otherData,
                BU: businessUnity?.name,
                lpEvent: eventData?.name,
                BUId: businessUnity?.id,
                eventId: eventData?._id,
                deviceType: isMobile ? 'mobile' : 'desktop',
                lpVersion: lpVersion && eventData?._id === TEST_AB_EVENT_ID ? lpVersion : undefined,
                deviceId: analyticsDeviceId
            },
            origin: 'LPEvents',
            target
        }])
    }

    return {
        sendActionEvent,
        sendInstantEvent
    }
}